import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  DatePicker,
  message,
  Tabs,
} from 'antd';
import {
  DownOutlined,
  UpOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import Moment from 'moment';
import { useSelector } from 'react-redux';
import { formatReceived } from 'utils/formatValues';
import Table from 'components/Table';
import Password from 'components/Password';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import LadaNumero from 'components/LadaNumero';
import AvatarUploader from 'components/AvatarUploader';
import Uploader from 'components/Uploader';
import PlainTransfer from 'components/PlainTransfer';
import Select from 'components/Select';
import {
  defaultOptions,
  allRequirementsPassed,
  validatePasswordRequirements,
} from 'utils/passwordRequirements';
import { onError } from 'utils/handlers';
import { getModelPermission, isAdmin } from 'utils/permission/index';
import { permissionConfig as permissionRoles } from 'views/Configuracion/Roles';
// import NumericInput from 'components/NumericInput';
import { getPermisos } from 'api/usuarios/permission';
import { getGrupos } from 'api/catalogos/grupos';
import { getFunciones } from 'api/usuarios/funciones';
import { getJustificaciones } from 'api/usuarios/justificaciones';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { getCanalesDePago } from 'api/configuracion/canalDePago';
import {
  deleteUsuario,
  getUsuario,
  getUsuarios,
  patchPermisosUsuario,
  patchRolesUsuario,
  patchUsuario,
  postUsuario,
  baseURI,
} from 'api/usuarios/usuarios';
import { getFuncionarios } from 'api/usuarios/funcionarios';
import { changePassword, getCurrentUser } from 'api/usuarios';
import { getConfiguracionesDeSegmentosDeFolios } from 'api/configuracion/configuracionesDeFolios';
import { getTerminalesDeNetPay } from 'api/configuracion/terminalDeNetPay';
import checkToken from 'api/utils/checkToken';
import { generateRFCRules } from 'utils/rules';
import { toUpper } from 'utils/normalizers';
import { getSubUnidadesDeRecaudacion } from 'api/configuracion/subUnidadesDeRecaudacion';

const permissionModel = 'permission';
const { TextArea } = Input;
const { TabPane } = Tabs;

export const permissionConfig = {
  permissionModel: 'usuario',
  catalogsModels: [
    'group',
    'entidad',
    'funciondelusuarioexterno',
    'justificaciondeusuarioexterno',
    'unidadderecaudacion',
    'canaldepago',
    'permission',
    'terminaldenetpay',
  ],
};

// eslint-disable-next-line react/prop-types
const Usuarios = ({ permission }) => {
  const { user, entidad } = useSelector(({ auth }) => auth);
  const permisos = useSelector(({ catalogs }) => catalogs.permisos);
  const [form] = Form.useForm();
  const [formPersonales] = Form.useForm();
  const [formRoles] = Form.useForm();
  const [formPermisos] = Form.useForm();
  const [formSistema] = Form.useForm();
  const [formFirma] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visiblePwd, setVisiblePwd] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [empleadosData, setEmpleadosData] = useState([]);
  const [funciones, setFunciones] = useState([]);
  const [justificaciones, setJustificaciones] = useState([]);
  const [isExterno, setIsExterno] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [options, setOptions] = useState(defaultOptions);
  const [roles, setRoles] = useState([]);
  const [initRoles, setInitRoles] = useState();
  const [initPermisos, setInitPermisos] = useState();
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [isMutable, setIsMutable] = useState(true);
  const [canalesDePago, setCanalesDePago] = useState([]);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);
  const [subUnidadesDeRecaudacion, setSubUnidadesDeRecaudacion] = useState([]);
  const [rolesPermission, setRolesPermission] = useState(null);
  const [permissionPermission, setPermissionPermission] = useState(null);
  const [folios, setFolios] = useState([]);
  const [terminalesDeNetpay, setTerminalesDeNetpay] = useState([]);

  const basicKeys = ['general', 'info_usuario', 'roles', 'permisos', 'sistema', 'firma'];
  const formInstances = [form, formPersonales, formRoles, formPermisos, formSistema];

  const me = user?.id === selectedRowKeys[0];

  const normalizeDataForTransfer = (_data, prop) => {
    if (_data?.length) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeDataForTransfer(clone.children, prop);
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            value: clone.id,
            title: `${item.id} - ${item.name}`,
            key: clone.id.toString(),
            selectable: item.seleccionable,
            checkable: item.seleccionable,
          });
        }
        return ({
          ...clone,
          value: clone.id,
          title: `${item.id} - ${item.name}`,
          children,
          disabled: true,
          selectable: item.seleccionable,
          key: clone.id.toString(),
        });
      });
      return output;
    }
    return [];
  };

  const fetchData = async () => {
    setLoading(true);
    const _usuarios = await getUsuarios();
    setData(formatReceived(_usuarios.map((e) => ({
      ...e,
      nombre_completo: `${e?.first_name || ''} ${e?.last_name || ''} ${e?.second_last_name || ''}`,
    }))));
    const usersWithEmpleado = _usuarios.filter((u) => !u.es_externo && u.empleado)
      .map((u) => u.empleado);
    const empleadosWithFlag = empleadosData.map((e) => ({
      ...e,
      nombre_completo: `${e.first_name} ${e.last_name} ${e.second_last_name || ''} `,
      disabled: usersWithEmpleado.includes(e.id),
    }));
    setEmpleados(empleadosWithFlag
      .sort((a, b) => a.disabled.toString().localeCompare(b.disabled)));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _roles,
        _funciones,
        _justificaciones,
        _unidadesDeRecaudacion,
        _canalesDePago,
        _usuarios,
        _empleados,
        _folios,
        _terminalesDeNetpay,
      ] = await Promise.all([
        getGrupos(),
        getFunciones(),
        getJustificaciones(),
        getUnidadesDeRecaudacion(),
        getCanalesDePago(),
        getUsuarios(),
        getFuncionarios(),
        getConfiguracionesDeSegmentosDeFolios(),
        getTerminalesDeNetPay(),
        getPermisos(),
      ]);
      const normalizedRoles = normalizeDataForTransfer(_roles, 'nombre_completo');
      const usersWithEmpleado = _usuarios.filter((u) => !u.es_externo && u.empleado)
        .map((u) => u.empleado);
      const empleadosWithFlag = _empleados.map((e) => ({
        ...e,
        nombre_completo: `${e.first_name} ${e.last_name} ${e.second_last_name || ''} `,
        disabled: usersWithEmpleado.includes(e.id),
      }));
      if (mounted) {
        setRoles(normalizedRoles);
        setFunciones(_funciones);
        setJustificaciones(_justificaciones || []);
        setUnidadesDeRecaudacion(_unidadesDeRecaudacion);
        setCanalesDePago(_canalesDePago);
        setData(formatReceived(_usuarios.map((e) => ({
          ...e,
          nombre_completo: `${e?.first_name || ''} ${e?.last_name || ''} ${e?.second_last_name || ''}`,
        }))));
        setEmpleadosData(_empleados);
        setEmpleados(empleadosWithFlag
          .sort((a, b) => a.disabled.toString().localeCompare(b.disabled)));
        setFolios(_folios);
        setTerminalesDeNetpay(_terminalesDeNetpay);
        setLoading(false);
      }
    };

    fetchAll();

    const _rolesPermission = getModelPermission(permissionRoles.permissionModel);
    setRolesPermission(_rolesPermission);
    const _permissionPermission = getModelPermission(permissionModel);
    setPermissionPermission(_permissionPermission);

    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setOptions(defaultOptions);
    setVisible(false);
    form.resetFields();
    formPersonales.resetFields();
    formPermisos.resetFields();
    formRoles.resetFields();
    formSistema.resetFields();
    formFirma.resetFields();
    setSelectedRowKeys([]);
    setVisiblePwd(false);
    setIsExterno();
    setIsMutable(true);
    setCurrentTabKey('general');
    setInitPermisos([]);
    setInitRoles([]);
  };

  const arrEquals = (array1 = [], array2 = []) => {
    const array1Sorted = array1.slice().sort();
    const array2Sorted = array2.slice().sort();
    if (array1Sorted.length !== array2Sorted.length) {
      return false;
    }
    return array1Sorted.sort().every((val, idx) => val === array2Sorted[idx]);
  };

  const setRolesPermisos = async (key) => {
    const { roles: _roles = [] } = formRoles.getFieldsValue();
    const { permisos: _permisos = [] } = formPermisos.getFieldsValue();
    if (!arrEquals(initRoles, _roles)) {
      await patchRolesUsuario(key, _roles);
    }
    if (!arrEquals(initPermisos, _permisos)) {
      await patchPermisosUsuario(key, _permisos);
    }
  };

  const handleChangePassword = async (values) => {
    const shouldConfirmCurrentPassword = !isAdmin();
    const hasPasswordValues = values.password || values.confirmPassword || values.currentPassword;

    if (!hasPasswordValues) return true;

    if (!values.password
      || !values.confirmPassword
      || (shouldConfirmCurrentPassword && !values.currentPassword)
      || values.password !== values.confirmPassword) return false;

    const newPassword = {
      contrasena: values.currentPassword,
      contrasena_nueva: values.password,
    };

    if (isAdmin()) {
      const [key] = selectedRowKeys;
      newPassword.idUsuario = key;
    }

    const changed = await changePassword(newPassword);
    return changed;
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      await formPersonales.validateFields();
      await formRoles.validateFields();
      await formPermisos.validateFields();
      await formSistema.validateFields();
      await formFirma.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formPersonales.getFieldsValue(),
        ...formSistema.getFieldsValue(),
      };

      const { firma_autografa_imagen, ...valuesFirma } = formFirma.getFieldsValue();
      valuesFirma.cert = typeof valuesFirma.cert !== 'boolean' ? valuesFirma.cert : undefined;
      valuesFirma.firma_clave_privada = typeof valuesFirma.firma_clave_privada !== 'boolean' ? valuesFirma.firma_clave_privada : undefined;
      valuesFirma.firma_pass_clave = typeof valuesFirma.firma_pass_clave !== 'boolean' ? valuesFirma.firma_pass_clave : undefined;
      values.valuesFirma = valuesFirma;
      values.firma_autografa_imagen = firma_autografa_imagen;

      const [key] = selectedRowKeys;
      if (key) {
        const changed = await handleChangePassword(values);

        delete values.password;
        delete values.confirmPassword;
        delete values.currentPassword;

        if (!changed) {
          setLoading(false);
          setCurrentTabKey('info_usuario');
          return;
        }
      }

      const saved = await (key ? patchUsuario(key, values) : postUsuario(values));
      if (saved) {
        await setRolesPermisos(saved.id);
        if (saved.id === user.id) {
          await getCurrentUser();
        }
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances, setCurrentTabKey);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteUsuario(key);
    if (deleted) {
      onCancel();
      setVisibleAlert(false);
      await fetchData();
    }
    setLoading(false);
  };

  const filter = async () => {
    try {
      setLoading(true);
      const { unidad_de_recaudacion } = formSistema.getFieldsValue();
      if (unidad_de_recaudacion) {
        const _subUnidades = await getSubUnidadesDeRecaudacion({ unidad_de_recaudacion });
        setSubUnidadesDeRecaudacion(_subUnidades || []);
      } else {
        setSubUnidadesDeRecaudacion([]);
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickEdit = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const record = await getUsuario(key);
    if (record) {
      setIsExterno(!record.es_externo);
      setInitRoles(record.roles);
      setInitPermisos(record.permisos);
      formRoles.setFieldsValue({ roles: record.roles });
      formPermisos.setFieldsValue({ permisos: record.permisos });
      formPersonales.setFieldsValue(formatReceived(record));
      formSistema.setFieldsValue(record);
      formFirma.setFieldsValue({
        ...record,
        firma_pass_clave: record.firma_pass_clave || undefined,
      });
    }
    setLoading(false);
    setVisible(true);
  };

  const onClickDelete = () => {
    const [id] = selectedRowKeys;
    if (user.id !== id) {
      setVisibleAlert(true);
    } else {
      message.info('No puede eliminarse el usuario de la sesión actual');
    }
  };

  const onChangeTabKey = (key) => {
    const fromBasic = basicKeys.includes(currentTabKey);
    const toBasic = basicKeys.includes(key);
    if (fromBasic && toBasic) {
      setCurrentTabKey(key);
    }
  };

  let timeout = null;
  const onFormValuesChange = (changedValues, allValues) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      const { password } = changedValues;
      if (password) {
        const newOps = validatePasswordRequirements(password, 33);
        setOptions(newOps);
      } else if (!allValues.password) {
        setOptions(defaultOptions);
      }
      formPersonales.validateFields(['password', 'confirmPassword']);
    }, 500);
  };

  const columns = [
    {
      titleText: 'Correo Electrónico',
      dataIndex: 'email',
      key: 'email',
      width: 300,
    },
    {
      titleText: 'Nombre Completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
      width: 350,
    },
    {
      titleText: 'Unidad de Recaudación',
      dataIndex: 'unidad_de_recaudacion',
      key: 'unidad_de_recaudacion',
      width: 350,
      catalog: {
        cat: unidadesDeRecaudacion,
        labelProp: 'descripcion',
      },
    },
  ];

  const required = { required: true };

  const rules = {
    required: [required],
    requiredConditionally: [{ required: isExterno }],
    email_alternativo: [{ type: 'email' }],
    email: [required, { type: 'email' }],
    password: [
      {
        validator: async () => {
          const pwd = formPersonales.getFieldValue('password');
          if (!allRequirementsPassed(pwd)) {
            throw new Error('La contraseña no cumple con los requisitos');
          }
        },
      },
    ],
    confirmPassword: [
      {
        validator: async (rule, value) => {
          const pwd = formPersonales.getFieldValue('password');
          if (value && value !== pwd) {
            throw new Error('Las contraseñas no coinciden.');
          }
        },
      },
    ],
    rfc: generateRFCRules({ tipoDePersona: 1 }),
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            mobileColIndex={0}
            rowKey="id"
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            baseURI={baseURI}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Usuario`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                permission={permission}
              />
            )}
            bordered={false}
          >
            <Tabs
              onChange={isMutable ? onChangeTabKey : setCurrentTabKey}
              activeKey={currentTabKey}
              type="card"
            >
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    Informacion General
                  </span>
                )}
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={form}
                  name="general"
                  onFinish={() => onFinish()}
                  scrollToFirstError
                  initialValues={{ es_externo: true }}
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_externo"
                        label="¿Es un Funcionario?"
                        hasFeedback
                      >
                        <Select
                          onChange={(value) => {
                            if (value) {
                              form.resetFields();
                              const [key] = selectedRowKeys;
                              const match = key ? data.find((e) => e.id === key) : {};
                              delete match.es_externo;
                              form.setFieldsValue({
                                is_active: false,
                                ...match,
                                es_externo: value,
                              });
                            }
                            setIsExterno(!value);
                          }}
                          trueFalse
                        />
                      </Form.Item>
                    </Col>
                    {!isExterno && (
                      <Col xs={24} sm={24} md={16}>
                        <Form.Item
                          name="funcionario"
                          rules={rules.required}
                          label="Funcionario"
                          hasFeedback
                        >
                          <Select
                            onChange={(key) => {
                              const selectedEmpleado = empleados
                                .find((e) => e.id === key);
                              form.setFieldsValue({
                                ...form.getFieldsValue(),
                                first_name: selectedEmpleado.nombre,
                                last_name: selectedEmpleado.apellido_paterno,
                                second_last_name: selectedEmpleado.apellido_materno,
                                email: selectedEmpleado.correo_electronico,
                                lada: selectedEmpleado.lada,
                                numero_de_celular: selectedEmpleado.numero_de_celular,
                              });
                              formPersonales.setFieldsValue({
                                ...formPersonales.getFieldsValue(),
                                observaciones: selectedEmpleado.observacion,
                              });
                              const { roles: _roles, permisos: _permisos } = selectedEmpleado;
                              formRoles.setFieldsValue({
                                roles: _roles,
                              });
                              formPermisos.setFieldsValue({
                                roles: _permisos,
                              });
                            }}
                            disabled={isExterno}
                            render={(f) => `${f.nombre}`}
                            dataSource={empleados}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="first_name"
                        rules={rules.required}
                        label="Nombre"
                        hasFeedback
                      >
                        <Input allowClear disabled={!isExterno && !selectedRowKeys.length} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="last_name"
                        rules={rules.required}
                        label="Apellido Paterno"
                        hasFeedback
                      >
                        <Input allowClear disabled={!isExterno && !selectedRowKeys.length} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="second_last_name"
                        rules={rules.second_last_name}
                        label="Apellido Materno"
                        hasFeedback
                      >
                        <Input allowClear disabled={!isExterno && !selectedRowKeys.length} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="numero_de_empleado"
                        label="Número de Empleado"
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    {isExterno && (
                      <>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="funcion_del_usuario_externo"
                            label="Función"
                            hasFeedback
                          >
                            <Select dataSource={funciones} />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="justificacion"
                            label="Justificación"
                            hasFeedback
                          >
                            <Select dataSource={justificaciones} />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    <LadaNumero
                      form={form}
                      rules={rules}
                      names={{
                        lada: 'lada',
                        numero_de_telefono: 'numero_de_celular',
                      }}
                      celular
                    />
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="email"
                        rules={rules.email}
                        label="Correo Electrónico"
                        hasFeedback
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="email_alternativo"
                        rules={rules.email_alternativo}
                        label="Correo Alternativo"
                        hasFeedback
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col md={8} sm={24} xs={24}>
                      <Form.Item
                        label="Foliador"
                        name="foliador"
                      >
                        <Select
                          dataSource={folios}
                          render={(e) => `${e.descripcion} (${e.separador})`}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <AvatarUploader
                        form={form}
                        imageURL={form.getFieldValue('foto')}
                      />
                    </Col>
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    Información del Usuario
                  </span>
                )}
                key="info_usuario"
                forceRender
              >
                <Form
                  layout="vertical"
                  name="info_usuario"
                  form={formPersonales}
                  scrollToFirstError
                  onFinish={() => onFinish()}
                  onValuesChange={onFormValuesChange}
                >
                  <Row gutter={10} style={{ width: '100%' }}>
                    <Col xs={24} sm={24}>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="is_active"
                            rules={rules.required}
                            label="Activo"
                            hasFeedback
                          >
                            <Select trueFalse />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_de_vencimiento"
                            label="Fecha de Vencimiento"
                            hasFeedback
                          >
                            <DatePicker
                              disabledDate={(date) => date.isBefore(new Moment())}
                              format="DD/MM/YYYY"
                              placeholder=""
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={16}>
                          <Form.Item
                            name="observaciones"
                            label="Observaciones"
                            hasFeedback
                          >
                            <TextArea autoSize />
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Button
                            onClick={() => setVisiblePwd(!visiblePwd)}
                            className="no-color primary-on-hover"
                            style={{ borderRadius: 6, marginBottom: 10 }}
                            // eslint-disable-next-line react/prop-types
                            disabled={!((me && permission?.change) || isAdmin())}
                            icon={!visiblePwd ? <DownOutlined /> : <UpOutlined />}
                          >
                            Asignar contraseña
                          </Button>
                        </Col>

                        {visiblePwd && (
                          <Password
                            rules={rules}
                            options={options}
                            confirmCurrentPassword={!isAdmin()}
                          />
                        )}
                        <br />
                        <br />
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </TabPane>
              {(rolesPermission?.view && isAdmin()) && (
                <TabPane
                  tab={(
                    <span>
                      <InfoCircleOutlined />
                      Roles
                    </span>
                  )}
                  key="roles"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    name="roles"
                    form={formRoles}
                  >
                    <Col span={24}>
                      <PlainTransfer
                        dataSource={roles}
                        label="Roles"
                        formItemName="roles"
                        form={formRoles}
                        filterProp="name"
                        disabled={!rolesPermission?.change}
                      />
                    </Col>
                  </Form>
                </TabPane>
              )}
              {(permissionPermission?.view && isAdmin()) && (
                <TabPane
                  tab={(
                    <span>
                      <InfoCircleOutlined />
                      Permisos
                    </span>
                  )}
                  key="permisos"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    name="permisos"
                    form={formPermisos}
                  >
                    <Col span={24}>
                      <PlainTransfer
                        dataSource={permisos}
                        label="Permisos"
                        formItemName="permisos"
                        form={formPermisos}
                        filterProp="name"
                        disabled={!permissionPermission?.change}
                      />
                    </Col>
                  </Form>
                </TabPane>
              )}
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    Sistema
                  </span>
                )}
                key="sistema"
                forceRender
              >
                <Form
                  layout="vertical"
                  name="sistema"
                  form={formSistema}
                  onFinish={() => onFinish()}
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        label="Terminal de Netpay"
                        name="terminal_netpay"
                        rules={entidad?.solo_pago_netpay ? rules.required : null}
                      >
                        <Select dataSource={terminalesDeNetpay} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="canal_de_pago"
                        label="Canal de Pago"
                      >
                        <Select dataSource={canalesDePago} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="unidad_de_recaudacion"
                        label="Unidad de Recaudación"
                      >
                        <Select
                          dataSource={unidadesDeRecaudacion}
                          onChange={filter}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="subunidad_de_recaudacion"
                        label="Subunidad de Recaudación"
                      >

                        <Select
                          dataSource={subUnidadesDeRecaudacion}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    Firma electrónica
                  </span>
                )}
                key="firma"
                forceRender
              >
                <Form
                  layout="vertical"
                  name="firma"
                  form={formFirma}
                  onFinish={() => onFinish()}
                >
                  <Row gutter={10}>
                    <Uploader
                      title="Certificado (.cer)"
                      limitMB={2}
                      file={formFirma.getFieldValue('cert')}
                      formItemName="cert"
                      allowedExtensions={['cer']}
                      allowPreview={false}
                    />
                    <Uploader
                      title="Clave privada (.key)"
                      limitMB={2}
                      file={formFirma.getFieldValue('firma_clave_privada')}
                      formItemName="firma_clave_privada"
                      allowedExtensions={['key']}
                      allowPreview={false}
                    />
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="firma_pass_clave"
                        label="Contraseña de Clave Privada"
                      >
                        <Input.Password visibilityToggle={false} allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="firma_rfc"
                        rules={rules.rfc}
                        label="RFC"
                        normalize={toUpper}
                      >
                        <Input maxLength={13} allowClear />
                      </Form.Item>
                    </Col>
                    <Uploader
                      title="Firma autografa (.png)"
                      limitMB={2}
                      formItemName="firma_autografa_imagen"
                      allowedExtensions={['png']}
                      allowPreview
                      rules={[
                        {
                          validator: async (_, value) => {
                            if (!value || !value.file) {
                              return Promise.resolve();
                            }

                            return new Promise((resolve, reject) => {
                              const img = new Image();
                              img.onload = () => {
                                const { width, height } = img;

                                if (width > 700 || height > 300) {
                                  reject(new Error('Las dimensiones de la imagen no pueden ser mayores a 700x300 píxeles'));
                                } else if (width < 600 || height < 200) {
                                  reject(new Error('Las dimensiones de la imagen deben ser mayores a 600x200 píxeles'));
                                } else {
                                  resolve();
                                }
                              };

                              img.onerror = () => {
                                reject(new Error('Error al cargar la imagen'));
                              };

                              const fileReader = new FileReader();
                              fileReader.onload = (e) => {
                                img.src = e.target.result;
                              };
                              fileReader.readAsDataURL(value.file);
                            });
                          },
                        },
                      ]}
                    />
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </TabPane>
            </Tabs>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content={`usuario ${form.getFieldValue('email')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default Usuarios;
